import { render } from "./ConfirmDeleteModal.vue?vue&type=template&id=22cb4700&scoped=true"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"

import "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=22cb4700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cb4700"]])

export default __exports__